/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';

/**
 * A command used to modify the version of a document.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class ChangeVersionCommand extends AbstractCommand {
    public _newVersion : string;

    public _oldVersion : string;

    public _nullInfo : boolean;

    public constructor(newVersion? : any) {
        if(((typeof newVersion === 'string') || newVersion === null)) {
            let __args = arguments;
            super();
            if(this._newVersion===undefined) this._newVersion = null;
            if(this._oldVersion===undefined) this._oldVersion = null;
            if(this._nullInfo===undefined) this._nullInfo = false;
            if(this._newVersion===undefined) this._newVersion = null;
            if(this._oldVersion===undefined) this._oldVersion = null;
            if(this._nullInfo===undefined) this._nullInfo = false;
            (() => {
                this._newVersion = newVersion;
            })();
        } else if(newVersion === undefined) {
            let __args = arguments;
            super();
            if(this._newVersion===undefined) this._newVersion = null;
            if(this._oldVersion===undefined) this._oldVersion = null;
            if(this._nullInfo===undefined) this._nullInfo = false;
            if(this._newVersion===undefined) this._newVersion = null;
            if(this._oldVersion===undefined) this._oldVersion = null;
            if(this._nullInfo===undefined) this._nullInfo = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[ChangeVersionCommand] Executing.");
        if(ModelUtils.isNullOrUndefined(document.info)) {
            document.info = document.createInfo();
            this._nullInfo = true;
            this._oldVersion = null;
        } else {
            this._oldVersion = document.info.version;
        }
        document.info.version = this._newVersion;
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[ChangeVersionCommand] Reverting.");
        if(this._nullInfo) {
            document.info = null;
        } else {
            document.info.version = this._oldVersion;
        }
    }
}
ChangeVersionCommand["__class"] = "io.apicurio.datamodels.cmd.commands.ChangeVersionCommand";
ChangeVersionCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




